// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-description-item {
  margin-top: 1.2rem;
}
.add-description-item textarea {
  width: 100%;
  min-height: 6.4rem;
  margin: 0.6rem 0;
  padding: 0.8rem;
  border: 1px solid #c4c4c4;
  resize: vertical;
}
.add-description-item i {
  display: block;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/OverclaimView/DocumentForms/AddDescriptionForm/index.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AADJ;AAIE;EACE,cAAA;EACA,gBAAA;AAFJ","sourcesContent":["@use '@Styles/variables';\n\n.add-description-item {\n  margin-top: 1.2rem;\n\n  textarea {\n    width: 100%;\n    min-height: 6.4rem;\n    margin: 0.6rem 0;\n    padding: 0.8rem;\n    border: 1px solid variables.$greyColorForBorder;\n    resize: vertical;\n  }\n\n  i {\n    display: block;\n    line-height: 1.4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
